import { render, staticRenderFns } from "./AutocompleteSelect.vue?vue&type=template&id=5bf0ff67"
import script from "./AutocompleteSelect.vue?vue&type=script&lang=js"
export * from "./AutocompleteSelect.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteSelect.vue?vue&type=style&index=0&id=5bf0ff67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports